import { createSlice } from "@reduxjs/toolkit";

export const SelectedProjectWorkflowSlice = createSlice({
    name : 'selected_project_workflow',
    initialState : {
        value : {}
    },
    reducers : {
        updateSelectedProjectWorkflow : (state, action) => {
            state.value = action.payload
        }
    }
});

export const { updateSelectedProjectWorkflow } = SelectedProjectWorkflowSlice.actions

export default SelectedProjectWorkflowSlice.reducer